<template>
  <div>
    <div class="row justify-content-center">
      <div class="col-12 " style="padding-top:0">
        <div class="">
          <div class="card-body d-flex flex-column pb-10">
            <div class="row">
              <div class=" font-size-h3 mb-8 col-6" v-if="tag">
                <span class="font-weight-bolder">Forum</span> · Add a question
                in
                <span class="font-weight-bolder">{{ tag.name }}</span>
              </div>
            </div>
            <div class="card">
              <div class="card-body">
                <b-form v-on:submit.prevent="sendQuestion(me)">
                  <div class="form-group">
                    <v-text-field
                      v-model="form.title"
                      label="Title Question"
                      hide-details="auto"
                    ></v-text-field>
                  </div>
                  <div class="form-group">
                    <label>Description:</label>
                    <vue-editor
                      id="textarea2"
                      :editor-toolbar="customToolbar"
                      v-model="form.description"
                    ></vue-editor>
                  </div>
                  <div class="form-group">
                    <label>is it related to any project?</label>
                    <select
                      v-model="form.project"
                      type="text"
                      class="form-control form-control-lg"
                      ref="project"
                      name="project"
                    >
                      <option value="null">Select project</option>
                      <option
                        :value="p._id"
                        v-for="p of activeProjects"
                        :key="p._id"
                      >
                        {{ p.title }}
                      </option>
                    </select>
                  </div>
                  <input
                    type="submit"
                    value="Publish"
                    class="btn mt-2 btn-info"
                  />
                </b-form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import axios from "axios";

export default {
  name: "forum-single",
  components: {},
  data() {
    return {
      series: [],
      form: { project: null, title: null, description: null },
      customToolbar: [
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
        ["blockquote", "code-block"],
        [{ indent: "-1" }, { indent: "+1" }],
        ["link", "clean"]
      ]
    };
  },

  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: "Forum",
        subtitle: "Add question"
      }
    ]);
  },
  methods: {
    checkAdmin(roles, user) {
      let admin = roles.find(r => r.name === "admin");
      let isAdmin = admin ? user.roles.includes(admin._id) : null;
      return isAdmin;
    },
    sendQuestion(user) {
      console.log(user, this.form);
      this.form.user = user._id;
      this.form.tag = this.$route.params.tagId;
      this.form.isActive = true;
      if (this.form.project === "null") {
        this.form.project = null;
      }
      axios.post("forum/", this.form).then(response => {
        console.log("response", response);
        this.$store.dispatch("fetchForums");
        this.$router.push("/forums");
      });
    }
  },
  computed: {
    me() {
      return this.$store.getters.getMyUser;
    },
    admin() {
      let roles = this.$store.getters.getRoles.find(
        r => r.name === "admin" || r.name === "teacher"
      );

      let isAdmin = roles
        ? this.$store.getters.getMyUser.roles.includes(roles._id)
        : null;
      return isAdmin;
    },
    roles() {
      return this.$store.getters.getRoles;
    },
    tag() {
      return this.$store.getters.getTags.find(
        f => f._id === this.$route.params.tagId
      );
    },
    activeProjects() {
      return this.$store.getters.getProjects.filter(
        p => p.isActive && !p.hasParent
      );
    },
    projects() {
      return this.$store.getters.getProjects;
    },
    profiles() {
      return this.$store.getters.getProfiles;
    },
    ...mapGetters(["currentUser"])
  }
};
</script>

<style></style>
